import { skipToken } from "@reduxjs/toolkit/query";

import { useGetProjectLatestVersionQuery } from "apis/dataV2/dataV2Api";
import { useAppSelector } from "app/redux-store-interactions";
import { useSceneId } from "hooks/useSceneId";
import { selectIsProcoreDesign, selectProjectV2Info } from "slices/explorer";

const POLLING_INTERVAL = 300000;

export function useProjectLatestVersion({
    poll,
    refetchOnMountOrArgChange,
}: { poll?: boolean; refetchOnMountOrArgChange?: boolean } = {}) {
    const sceneId = useSceneId();
    const projectInfo = useAppSelector(selectProjectV2Info);
    const projectId = projectInfo?.id ?? sceneId;
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);
    return useGetProjectLatestVersionQuery(projectId && !isProcoreDesign ? { projectId } : skipToken, {
        pollingInterval: poll ? POLLING_INTERVAL : undefined,
        skipPollingIfUnfocused: true,
        refetchOnMountOrArgChange,
        refetchOnFocus: true,
    });
}
